export const SET_QUESTIONNAIRE = "SET_QUESTIONNAIRE";
export const GET_QUESTIONNAIRE = "GET_QUESTIONNAIRE";
export const SET_QUESTIONS = "SET_QUESTIONS";
export const GET_QUESTIONS = "GET_QUESTIONS";
export const SET_QUESTION_TEXT = "SET_QUESTION_TEXT";
export const SET_QUESTION_VARIANT = "SET_QUESTION_VARIANT";
